import { CouponApplyErrorCode } from "../../core/enums";
import { CouponApplyPhase } from "./interfaces/coupon-qualifier.interface";
export class OrderTypeQualifier {
    phase = CouponApplyPhase.PreApply;
    qualify(coupon, cart) {
        if (!coupon.orderTypeIds.includes(cart.orderTypeId)) {
            return { isValid: false, errorCode: CouponApplyErrorCode.INVALID_ORDER_TYPE };
        }
        return { isValid: true, errorCode: null };
    }
}
//# sourceMappingURL=order-type.js.map